export const localPreferenceService = {
  findByNameAtUserLevel: (key) => {
    const data = localStorage.getItem(key);
    const value = data ? JSON.parse(data) : undefined;
    return { Name: key, Data: value };
  },
  setAtUserLevel: ({ Name, Data }) => {
    localStorage.setItem(Name, JSON.stringify(Data));
  },
};
